import styled from 'styled-components';
import { theme } from '@upsolve/ui';

const HintWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 550;
  width: 300px;
  max-width: 70vw;
  background: #FFF;
  margin: 32px 4px 12px 50px;
  border-radius: 6px;
  box-shadow: 0 8px 64px rgba(0, 2, 70, 0.175);
  font-size: 13px;
  text-align: left;
  color: ${theme.colors.gray['700']};
  cursor: pointer;
  .hint__clear {
    position: absolute;
    top: -38px;
    right: 0;
    padding: 3px 16px;
    background: ${theme.colors.gray['900']};
    color: white;
    border-radius: 6px;
    letter-spacing: 0.5px;
    &:hover {
      cursor: pointer;
    }
  }
  .hint__author {
    height: 40px;
    width: 40px;
    top: -16px;
    position: absolute;
    left: -24px;
    border-radius: 50%;
    background-image: url("${require('../../../../static/images/mary-g.png')}");
    background-size: cover;
    background-position: center;
    box-shadow: 0 1px 8px rgba(0, 2, 50, 0.3);
    @media(max-width: 45em) {
      left: 0;
      top: -44px;
    }
  }
  display: none;
  &.show-hint, &.show-form {
    display: block;
  }
  @media(max-width: 45em) {
    width: auto;
    max-width: none;
    margin: 0;
    box-shadow: 0 2px 180px rgba(0, 2, 80, 0.35);
    &.show-form {
      left: 12px;
      right: 12px;
      top: 48px;
      bottom: 12px;
    }
    &:not(.show-form) {
      left: 12px;
      right: 12px;
      bottom: 24px;
    }
  }
`;

export default HintWrapper;
